<template>
  <section class="p-members">
    <scroll-animation-unit>
      <h2 v-if="isMobile" class="c-heading u-fade">Staff</h2>
    </scroll-animation-unit>
    
    <color-overlay class="p-members__eyecatch">
      <img :src="mainImage" alt="" class="u-cover">
    </color-overlay>
    
    <scroll-animation-unit class="p-members__container">
      <div v-if="!isMobile" class="p-members__heading u-fade">Staff</div>
      <div class="p-members__content u-fade">
        <div class="p-members__lead" v-html="lead"></div>

        <div v-for="member in members" class="p-members__profile">
          <picture v-if="member.image" class="p-members__image">
            <img :src="member.image.url" alt="">
          </picture>
          <dl class="p-members__description">
            <dt>
              <em class="p-members__name">{{ member.name }}</em>
              <span class="p-members__title">{{ member.position }}</span>
            </dt>
            <dd v-html="member.lead"></dd>
          </dl>
        </div>
      </div>
    </scroll-animation-unit>
  </section>
</template>

<script>
  /**
   * Share Partial
   */

  export default {
    name: 'cominca-members',
    props: {
      mainImage: {
        type: String,
      },
      lead: {
        type: String,
      },
      members: {
        type: [Array, Boolean],
        default: () => {
          return []
        }
      }
    },
    computed: {
      isMobile() {
        return this.$window.viewport === 'mobile'
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/cominca-members.vue